import { useEffect, useState } from "react";
import { _HelpDesk } from "../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../core/services/dataBean/useDataBean"
import { BasicPage } from "../../theme/Component/BasicPage"
import { BasicTable, MASK_NUMBER } from "../../theme/Component/BasicTable";
import usePaginator from "../../theme/Component/usePaginator";

export const HelpDeskReport = () => {

    const _helpdesk = useDataBean(_HelpDesk);
    const { lista, setLista, setBean, bean } = _helpdesk;
    const paginador = usePaginator();
    const records = 15;

    

    useEffect(() => {
        getlista();
    }, [paginador.page])
    const getlista =()=>{
            _helpdesk.instance.getHelpDeskRender(paginador.page, records, {}).then(
            (resp: any) => {
                setLista(resp.List);
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (records));
                paginador.setRegiPerPage(records)
            }
        )
    }

    const head = [
        { title: 'Codigo', property: 'ProcedureAlphaCode', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
        { title: 'Solicitud', property: 'Observation', visible: true },
        { title: 'Solicitante', property: 'AccountFullName', visible: true },
        { title: 'Tipo Solicitud', property: 'HelpType', visible: true },
        { title: 'Estado', property: 'StateImpName', visible: true },
    ]

    return (
        <BasicPage titulo="Mesa de Ayuda">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean}
                        next={paginador.next}
                        pageTop={paginador.page}
                        back={paginador.back}
                        records={paginador}
                    ></BasicTable>
                </div>
            </div>
        </BasicPage>
    )
}